import { h, proxyCustomElement, HTMLElement, Host } from '@stencil/core/internal/client';
import { S as Skeleton } from './skeleton.js';
import { d as defineCustomElement$1 } from './iframe-input2.js';

const CardFormSkeleton = (props) => {
    const { isReady } = props;
    if (isReady) {
        return null;
    }
    return (h("div", { class: "container-fluid p-0" },
        h("div", { class: "mb-3" },
            h(Skeleton, { height: "18px", width: "100px" }),
            h(Skeleton, { height: "36px" })),
        h("div", { class: "row" },
            h("div", { class: "col-4 align-content-end" },
                h(Skeleton, { height: "18px", width: "80px" }),
                h(Skeleton, { height: "36px" })),
            h("div", { class: "col-4 align-content-end" },
                h(Skeleton, { height: "36px" })),
            h("div", { class: "col-4 align-content-end" },
                h(Skeleton, { height: "18px", width: "30px" }),
                h(Skeleton, { height: "36px" })))));
};

const CardForm = /*@__PURE__*/ proxyCustomElement(class CardForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.isReady = false;
    }
    componentDidRender() {
        const elements = [
            this.cardNumberIframeElement,
            this.expirationMonthIframeElement,
            this.expirationYearIframeElement,
            this.cvvIframeElement,
        ];
        Promise.all(elements.map((element) => {
            return new Promise((resolve) => {
                element.addEventListener('iframeLoaded', () => { resolve(); });
            });
        })).then(() => {
            this.isReady = true;
        });
    }
    async validate() {
        const cardNumberIsValid = await this.cardNumberIframeElement.validate();
        const expirationMonthIsValid = await this.expirationMonthIframeElement.validate();
        const expirationYearIsValid = await this.expirationYearIframeElement.validate();
        const cvvIsValid = await this.cvvIframeElement.validate();
        return cardNumberIsValid && expirationMonthIsValid && expirationYearIsValid && cvvIsValid;
    }
    async tokenize(clientId, paymentMethodMetadata, account) {
        return this.cardNumberIframeElement.tokenize(clientId, paymentMethodMetadata, account);
    }
    render() {
        return (h(Host, { key: '035f015833d7c16a99ffb3cc4c1b88f44928839f' }, h(CardFormSkeleton, { key: '4f6a98efb4bb1ec08bc7660fe8fb11cf1f91aac4', isReady: this.isReady }), h("div", { key: 'efe85d9a9f3cd1ecabd6014b4e6ef6a22dce94f1', class: "container-fluid p-0", style: {
                opacity: this.isReady ? '1' : '0',
                height: this.isReady ? 'auto' : '0',
            } }, h("div", { key: 'd72b1e2e6034d556eccbc6bd68b1469ce51ae257', class: "mb-3" }, h("iframe-input", { key: 'd5d4ae255037b01aced2c90c59bb74d65053b88a', inputId: "cardNumber", ref: (el) => (this.cardNumberIframeElement = el), label: "Card Number", iframeOrigin: `${this.iframeOrigin}/v2/cardNumber` })), h("div", { key: '1ff59862ecaf86c067638bc86a7a21425ee27ec0', class: "row" }, h("div", { key: '3f6803d69bc30890eb39f005c32c06d0cfb6cf0d', class: "col-4 align-content-end" }, h("iframe-input", { key: 'a328d46fbfea56f3fd483194a74e6d8520cbc2ae', inputId: "expirationMonth", ref: (el) => (this.expirationMonthIframeElement = el), label: "Expiration", iframeOrigin: `${this.iframeOrigin}/v2/expirationMonth` })), h("div", { key: '46594d660b45a68f5b578823ed54db1a570a0291', class: "col-4 align-content-end" }, h("iframe-input", { key: 'e107c2515d16a339d52a3b08f91537eca3c92a23', inputId: "expirationYear", ref: (el) => (this.expirationYearIframeElement = el), label: "", iframeOrigin: `${this.iframeOrigin}/v2/expirationYear` })), h("div", { key: '3df8a556f5e0bade368137a673e814774ad507b9', class: "col-4 align-content-end" }, h("iframe-input", { key: '3432154c7645eda22beb1fe180936357b5b4b2c2', inputId: "CVV", ref: (el) => (this.cvvIframeElement = el), label: "CVV", iframeOrigin: `${this.iframeOrigin}/v2/CVV` }))))));
    }
}, [0, "card-form", {
        "iframeOrigin": [1, "iframe-origin"],
        "isReady": [32],
        "validate": [64],
        "tokenize": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["card-form", "iframe-input"];
    components.forEach(tagName => { switch (tagName) {
        case "card-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CardForm);
            }
            break;
        case "iframe-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { CardForm as C, defineCustomElement as d };
